// get scroll bar width and set as css variable, with a defined minimum value to prevent layout shift
function getScrollbarWidth() {
    return Math.max(window.innerWidth - document.documentElement.clientWidth, 16);
} 
document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);